module.exports = __webpack_public_path__ + "img/Weblink.b642c15.svg";